export default __webpack_public_path__ + "static/media/kidney-grey.49e3da03.svg";